(() => {
  angular
    .module('app.campaign')
    .controller('AddTrackpointYoutubeModalController', AddTrackpointYoutubeModal);

  AddTrackpointYoutubeModal.$inject = [
    '$element',
    'close',
    'ModalService',
    'campaignsADH',
    'currentCampaign',
    'CampaignManagerService',
  ];

  function AddTrackpointYoutubeModal(
    $element,
    close,
    ModalService,
    campaignsADH,
    currentCampaign,
    CampaignManagerService,
  ) {
    const vm = this;
    vm.campaign = currentCampaign;
    vm.rootLayer = campaignsADH;
    vm.layer = [];
    vm.layerPath = [];
    vm.sourcesADH = [];
    vm.search = '';

    vm.showGuide = true;
    vm.hideGuide = () => vm.showGuide = false;

    const getLayer = itemId => {
      if (!itemId) {
        return vm.rootLayer;
      }

      let layer = null;
      const walk = current => {
        current.forEach(item => {
          if (item.id === itemId) {
            layer = item;
          }

          if (!layer) {
            walk(item.items);
          }
        });

        return layer;
      };

      return walk(vm.rootLayer.items);
    };

    const updateLayer = itemId => {
      vm.layer = getLayer(itemId);
      vm.updateLayerPath();
    };

    vm.showLayerForward = item => {
      if (item.items.length !== 0) {
        updateLayer(item.id);
      }
    };

    vm.showLayerBackward = () => {
      updateLayer(vm.layer.campaignId || vm.layer.accountId);
    };

    vm.showLayerBackwardButton = () => {
      if (!vm.search) {
        return true;
      }

      const { level } = vm.layer;

      switch (vm.activeTabId) {
        case 'accounts': return level !== 'root';
        case 'campaigns': return level !== 'root' && level !== 'accounts';
        case 'insertionOrders': return level === 'lineItems';
        case 'lineItems': return false;
        default: return false;
      }
    }

    vm.showOptions = () => vm.layer.level !== 'root' || vm.search;
    vm.showActions = () => vm.getLayerItems().length !== 0 &&
      (vm.layer.level !== 'root' ||
      (vm.search && ['campaigns', 'insertionOrders', 'lineItems'].includes(vm.activeTabId)));
    vm.actionDisabled = () => vm.getLayerItems().every(item => item.added || item.locked);

    vm.gotoLayer = layer => {
      if (layer === 'accounts') {
        updateLayer();
      }

      if (layer === 'campaigns') {
        updateLayer(vm.layer.accountId);
      }

      if (layer === 'insertionOrders') {
        updateLayer(vm.layer.campaignId);
      }

      if (layer === 'lineItems') {
        updateLayer(vm.layer.insertionOrderId);
      }
    };

    vm.updateLayerPath = () => {
      vm.layerPath = [{
        label: 'Accounts',
        goto: () => vm.gotoLayer('accounts'),
        itemInclude: 'campaigns',
      }];

      if ((vm.layer.name && !vm.layer.accountName) ||
          vm.layer.accountName ||
          vm.activeTabId === 'campaigns') {
        vm.layerPath.push({
          goto: () => vm.gotoLayer('campaigns'),
          label: vm.layer.accountName || vm.layer.name,
          title: 'campaigns in account',
          itemInclude: 'insertion orders',
        });
      }

      if ((vm.layer.accountName && !vm.layer.campaignName) ||
          (vm.layer.campaignName && !vm.layer.insertionOrderName) ||
          vm.activeTabId === 'insertionOrders') {
        vm.layerPath.push({
          goto: () => vm.gotoLayer('insertionOrders'),
          label: vm.layer.campaignName || vm.layer.name,
          title: 'insertion orders in campaign',
          itemInclude: 'line items',
        });
      }

      if ((vm.layer.accountName && vm.layer.campaignName && !vm.layer.insertionOrderName) ||
          vm.layer.insertionOrderName ||
          vm.activeTabId === 'lineItems') {
        vm.layerPath.push({
          goto: () => false,
          label: vm.layer.insertionOrderName || vm.layer.name,
          title: 'line items in insertion order',
        });
      }

      const lastItem = vm.layerPath[vm.layerPath.length - 1];

      lastItem.last = true;
      vm.layerTitle = lastItem.title;
      vm.itemInclude = lastItem.itemInclude;
    };



    /* -------------------------------------- */
    /* Check/uncheck logic                    */
    /* -------------------------------------- */
    const updateChildChecked = item => {
      const walk = items => {
        items.forEach(child => {
          child.locked = item.added;
          child.checked = item.checked || child.locked;

          if (child.items) {
            walk(child.items);
          }
        });
      };

      walk(item.items);
    };

    const updateRootChecked = () => {
      const everyChildChecked = (item, some) => {
        let checked = item.checked;

        const every = items => {
          if (!items || items.length === 0) {
            return false;
          }

          checked = some ?
            items.some(child => child.checked) :
            items.every(child => child.checked);

          if ((some && !checked) || (!some && checked)) {
            items.forEach(child => {
              every(child.items);
            });
          }
        };

        every(item.items);
        return checked;
      };

      const walk = item => {
        item.checked = everyChildChecked(item);
        item.indeterminate = !item.checked && everyChildChecked(item, true);

        item.items.forEach(child => {
          walk(child);
        });
      };

      vm.rootLayer.items.forEach(account => {
        account.items.forEach(campaign => {
          walk(campaign);
        })
      });
    };

    const getCheckedSources = () => {
      const sources = [];

      vm.rootLayer.items.forEach(account => {
        account.items.forEach(campaign => {
          if (campaign.checked && !campaign.added) {
            sources.push({
              id: campaign.id,
              name: campaign.name,
              type: campaign.type,
              meta: campaign.meta,
              account: campaign.accountId,
              provider: 'adh',
              isNew: true,
            });
          }

          if (campaign.indeterminate) {
            campaign.items.forEach(io => {
              if (io.checked && !io.added && !io.locked) {
                sources.push({
                  id: io.id,
                  name: io.name,
                  type: io.type,
                  meta: io.meta,
                  account: io.accountId,
                  provider: 'adh',
                  isNew: true,
                });
              }

              if (io.indeterminate) {
                io.items.forEach(li => {
                  if (li.checked && !li.added && !li.locked) {
                    sources.push({
                      id: li.id,
                      name: li.name,
                      type: li.type,
                      meta: li.meta,
                      account: li.accountId,
                      provider: 'adh',
                      isNew: true,
                    });
                  }
                });
              }
            });
          }
        });
      });

      return sources;
    };

    vm.initChecked = () => {
      const walk = item => {
        const itemAdded = !!vm.campaign.sources.find(src => src.id === item.id);
        item.checked = itemAdded;
        item.added = itemAdded;
        updateChildChecked(item);
        updateRootChecked();

        if (item.items) {
          item.items.forEach(child => {
            walk(child);
          });
        }
      };

      vm.rootLayer.items.forEach(account => {
        account.items.forEach(campaign => {
          walk(campaign);
        })
      });
      // updateRootChecked();
    };

    const addTrackpoint = () => {
      vm.sourcesADH = getCheckedSources();
    };

    vm.onCheckItem = (item, checked) => {
      item.checked = typeof checked !== 'undefined' ? checked : !item.checked;
      updateChildChecked(item);
      updateRootChecked();

      addTrackpoint();
    };

    vm.onCheckAll = checked => {
      vm.getLayerItems().forEach(item => {
        if (!item.added && !item.locked) {
          vm.onCheckItem(item, checked);
        }
      });
      updateRootChecked();
    };



    /* -------------------------------------- */
    /* Activation                             */
    /* -------------------------------------- */
    activate();

    function activate() {
      vm.initChecked();
      updateLayer();
    }



    /* -------------------------------------- */
    /* Search Tabs                            */
    /* -------------------------------------- */
    vm.tabs = [{
      id: 'accounts',
      label: 'Accounts',
    }, {
      id: 'campaigns',
      label: 'Campaigns',
    }, {
      id: 'insertionOrders',
      label: 'Insertion Orders',
    }, {
      id: 'lineItems',
      label: 'Line Items',
    }];

    vm.activeTabId = vm.tabs[0].id;
    vm.setActiveTab = tab => {
      vm.activeTabId = tab.id;
      vm.updateLayerPath();
    };
    vm.isActiveTab = tab => tab.id === vm.activeTabId;
    vm.getActiveTabLabel = () => vm.tabs.find(tab => tab.id === vm.activeTabId).label;



    /* ------------------------------------- */
    /* Found items                           */
    /* ------------------------------------- */
    const getMatchedByLevel = level => {
      const getMatched = items => items
        .filter(item => (
          item.name.includes(vm.search) ||
          item.id.includes(vm.search)
        )) || [];

        if (level === 'accounts') {
          return getMatched(vm.rootLayer.items);
        }

        if (level === 'campaigns') {
          return getMatched(
            vm.rootLayer.items
              .reduce((memo, item) => ([
                ...memo,
                ...item.items,
              ]), [])
            );
        }

        if (level === 'insertionOrders') {
          return getMatched(
            vm.rootLayer.items
              .reduce((memo, item) => ([
                ...memo,
                ...item.items.reduce((mem, io) => ([
                  ...mem,
                  ...io.items,
                ]), []),
              ]), [])
            );
        }

        if (level === 'lineItems') {
          return getMatched(
            vm.rootLayer.items
              .reduce((memo, item) => ([
                ...memo,
                ...item.items.reduce((mem, io) => ([
                  ...mem,
                  ...io.items.reduce((me, li) => ([
                    ...me,
                    ...li.items,
                  ]), []),
                ]), []),
              ]), [])
            );
        }
    };

    vm.getLayerItems = () => {
      const { level, items } = vm.layer;

      if (!vm.search) {
        return items;
      }

      const tabLayers = () => {
        const layers = ['root'];

        switch (vm.activeTabId) {
          case 'campaigns': layers.push('accounts'); break;
          case 'insertionOrders': layers.push('accounts', 'campaigns'); break;
          case 'lineItems': layers.push('accounts', 'campaigns', 'insertionOrders'); break;
        }

        return layers;
      };

      return tabLayers().includes(level) ? getMatchedByLevel(vm.activeTabId) : items;
    };

    vm.getMatchingItemsAmount = level => getMatchedByLevel(level || vm.activeTabId).length;
    vm.getMatchingItemsLevelName = () => vm.activeTabId;



    /* ------------------------------------- */
    /* Add new tracking points to campaign   */
    /* ------------------------------------- */
    const hasCollision = () => {
      let collision = false;
      vm.campaign.sources.forEach(source => {
        const campaign = vm.sourcesADH.find(src => src.id === source.campaignId);
        const io = vm.sourcesADH.find(src => src.insertionOrderId && (src.insertionOrderId === source.insertionOrderId));

        if (campaign || io) {
          let campaignWithItems = null;
          let ioWithItems = null;

          vm.rootLayer.items.forEach(account => {
            account.items.forEach(cmp => {
              if (campaign && (cmp.id === campaign.id)) {
                campaignWithItems = cmp;
              }

              if (io) {
                cmp.items.forEach(iOrder => {
                  if (iOrder.id === io.id) {
                    ioWithItems = iOrder;
                  }
                });
              }
            });
          });

          collision = {
            campaign: campaignWithItems && { ...campaignWithItems },
          };

          if (source.type === 'li') {
            collision = {
              ...collision,
              io: ioWithItems && { ...ioWithItems },
            };
          }
        }
      });

      return collision;
    };

    const addNewTrackpoints = () => {
      const collision = hasCollision();

      if (collision) {
        let sources = [];
        let rest = [];

        vm.campaign.sources.forEach(src => {
          const collide = vm.sourcesADH.find(adh => adh.id === src.campaignId || adh.id === src.insertionOrderId);
          const added = sources.find(adh => collide && collide.id === adh.id);

          if (!added) {
            sources.push(collide || src);
          }

          if (collide) {
            rest = [
              ...vm.sourcesADH.filter(adh => adh.id !== collide.id),
            ];
          }
        });

        vm.campaign.sources = [
          ...sources,
          ...rest,
        ];
      }

      if (!collision) {
        vm.campaign.sources = [
          ...vm.campaign.sources,
          ...vm.sourcesADH,
        ];
      }

      CampaignManagerService.showNewTrackpointsAddedNotification(true);
    };

    vm.addTrackpoints = () => {
      const collision = hasCollision();
      if (collision) {
        vm.close();

        ModalService
          .showModal({
            templateUrl: `../../assets/js/app/campaign/modals/trackpoint/warning/adhCollision.html?v=${window.BUILD_VERSION}`,
            controller: 'AdhCollisionModalController',
            controllerAs: 'adhCollisionModal',
            inputs: {
              collision,
              addNewTrackpoints,
            }
          }).then(modal => {
            modal.element.modal();
            modal.close.then(result => {});
          });
      } else {
        addNewTrackpoints();
        vm.close();
      }
    };



    /* ------------------------------------- */
    /* Modal close                           */
    /* ------------------------------------- */
    vm.close = () => {
      $element.modal('hide');
      close(null, 500);
    };

  }
})();
